module.exports = __webpack_public_path__ + "img/IMG-20210719-WA0010.6fbd991b.jpg";